import { CircularProgress, Grid, Typography } from "@material-ui/core";

import { useEffect } from "react";
import { useLocation } from "react-router";
import { useProveedoresProspectos } from "../../context/ProveedoresProspectosContext";

const ProveedorEdit = () => {
    const query = new URLSearchParams(useLocation().search);
    const { editLoaderMessage, handleLoadSolicitudEdit } = useProveedoresProspectos();

    const fnGetToken = async () => {
        const authparam = query.get("authparam");
        await handleLoadSolicitudEdit(authparam);
    };

    useEffect(() => {
        fnGetToken();
        // eslint-disable-next-line
    }, []);

    return (
        <Grid container spacing={3} style={{ marginTop: 30 }}>
            <Grid item xs={12} className="center">
                <CircularProgress />
                <Typography>{editLoaderMessage}</Typography>
            </Grid>
        </Grid>
    );
};

export default ProveedorEdit;
